import { configureStore } from '@reduxjs/toolkit';
import sessionStorage from 'redux-persist/lib/storage/session';
import { persistStore, persistReducer } from 'redux-persist';

import rootReducer from './reducers/index';

const persistConfig = {
  key: 'root',
  storage: sessionStorage,
  // Must stay in lockstep with the keys in reducers/index.js. An unlisted slice silently
  // stops persisting — no error, it just loses its state on reload.
  whitelist: [
    'app',
    'findings',
    'reference',
  ],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }),
});

export const persistor = persistStore(store);
export default store;
